import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClientProvider, QueryClient } from 'react-query';
import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { RecoilRoot } from 'recoil';

import 'config/i18n';
import theme from 'config/mui/theme';
import globalStyles from 'config/mui/global-styles';

import App from './App';

/* Uncomment to enable mocked mode */
// if (process.env.REACT_APP_MODE === 'mocked') {
//   // eslint-disable-next-line global-require
//   const { default: worker } = require('./mocks/browser');
//   worker.start();
// }

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={new QueryClient()}>
      <ThemeProvider theme={theme}>
        <RecoilRoot>
          <App />
        </RecoilRoot>
        <CssBaseline />
        {globalStyles}
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
